<template>
  <div class="similar-block">
    <div class="title">
      {{ title }}
    </div>
    <div v-for="(item, index) in data" :key="index" class="content">
      <nuxt-link :to="item.link" class="name">
        {{ item.name }}
      </nuxt-link>
      <div v-if="statistics" class="statistics">
        <div class="date">
          <Icon collection="v2" class="icon" icon="calendar-2" size="s" />{{
            dateToStringWithDelimiterShort(new Date(item.created_at))
          }}
        </div>
        <div v-if="item.comments > 0" class="comments">
          <Icon collection="v2" class="icon" icon="comment" size="s" />{{ item.comments || 0 }}
        </div>
        <div v-if="item.likes > 0" class="likes">
          <Icon collection="v2" class="icon" icon="like" size="s" />{{ item.likes || 0 }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Icon from '~/components/components/icon/Icon.vue';
import { dateToStringWithDelimiterShort } from '~/utils';
import { NewsItemModel } from '~/models';

defineProps({
  title: {
    type: String,
    default: '',
  },
  data: {
    type: Array as PropType<Array<NewsItemModel>>,
    default: (): Array<NewsItemModel> => [],
  },
  statistics: {
    type: Boolean,
    default: true,
  },
});
</script>

<style scoped lang="scss">
.similar-block {
  color: $color-text-dark-grey;
  transition:
    background-color $transition,
    color $transition;
  margin-bottom: 20px;
  display: grid;
  grid-gap: 20px;
}
.similar-block > .title {
  color: #000;
  font-size: 18px;
  font-weight: 500;
  line-height: 22px;
}
.similar-block > .content {
  padding: 20px;
  border-radius: $border-radius-m;
  background-color: #f5f7f9;
}
.similar-block > .content > .name {
  color: #000;
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
}
.similar-block > .content > .statistics {
  color: $color-potato-50;
  display: flex;
  font-size: 14px;
  margin-top: 10px;
}
.similar-block > .content > .statistics > div {
  margin-right: 15px;
  display: flex;
  align-items: center;
}
.similar-block > .content > .statistics > div > .icon {
  margin-right: 5px;
}
</style>
